<template>
  <v-row no-gutters class="data-tree-table-row">
    <v-col cols="12">
      <v-row
        no-gutters
        class="text-body-2 py-1 px-2"
        :style="`background-color: ${this.levelColors[level]}`"
        align="center"
        v-on="getRowListeners()"
      >
        <v-col
          cols="auto"
          v-for="(header, idx) of headers"
          :key="idx"
          :style="`width: ${idx === 0 ? headerWidth * 2 : headerWidth}%`"
        >
          <v-row
            no-gutters
            align="center"
            :justify="idx === 0 ? 'start' : headers.length === 2 && idx === 1 ? 'end' : 'center'"
            class="flex-nowrap"
            style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis"
          >
            <v-col v-if="idx === 0" cols="auto" :style="`margin-left: ${level * 25}px`">
              <v-icon v-if="hasChildrenKey" @click.stop="open = !open">
                {{ open ? 'mdi-menu-down' : 'mdi-menu-right' }}
              </v-icon>
            </v-col>
            <v-col cols="auto">
              {{ header.valueFormater ? header.valueFormater(element[header.key]) : element[header.key] }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <template v-if="weNeedToGoDeeper && open">
        <data-tree-table-row
          v-for="(chElement, idx) of element.childrens"
          :key="idx"
          :level="level + 1"
          :element="chElement"
          :headers="headers"
          :disable-zoom="disableZoom"
        />
      </template>
    </v-col>
  </v-row>
</template>
<script>
import DataTreeTableRow from '@/components/DataTreeTableRow';
export default {
  name: 'DataTreeTableRow',
  components: { DataTreeTableRow },
  props: {
    level: {
      type: Number,
      default: 0,
    },
    element: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      default: () => {
        return [
          { key: 'name', translationPath: 'sidebar.dataTree.name' },
          { key: 'area', translationPath: 'sidebar.dataTree.area' },
        ];
      },
    },
    disableZoom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasChildrenKey() {
      return this.element.childrens ? true : false;
    },
    weNeedToGoDeeper() {
      return this.element.childrens?.length ? true : false;
    },
    headerWidth() {
      return 100 / (this.headers.length + 1);
    },
  },
  data: () => ({
    levelColors: {
      0: 'rgba(0,0,0,0.05)',
      1: 'rgba(0,0,0,0.02)',
      2: 'rgba(0,0,0,0)',
    },
    open: false,
  }),
  methods: {
    getRowListeners() {
      return {
        ...(this.disableZoom
          ? {}
          : {
              click: () => {
                this.zoom(this.element);
              },
            }),
      };
    },
    zoom(element = this.element) {
      if (!element.bbox?.length) return;
      this.$root.$emit('fitView', element.bbox);
    },
  },
};
</script>
<style lang="scss" scoped>
.data-tree-table-row:not(:first-child) {
  @include border(top);
}
</style>
